export const PriceRuleLocationPointConstant = {
    Origin: 'ORIGIN',
    Destination: 'DESTINATION'
}